import utils from 'utils'
import revertDialog from './view/revertDialog.html'
import submitResultPage from './view/submitResult.html'
import stockService from '../../../../common/services/stockService'

export default class InvoiceListCtrl {
    constructor($scope, $uibModal, logger, httpRequest, $q, $state, sweetalert, invoiceOpenService, initSortService, $timeout, getOvatAmtService, resultTipService, batchHandle, getCodeAndNumber, batchFilterService) {
        $scope.pageState = {
            pageInvType: '1',
        }
        const aMonth = utils.genPeriodByMonth()
        if ($state.current.name === 'outputManage.FOManage.rollTypeInvoice.list') $scope.isRoll = true
        $scope.sysUkeyList = JSON.parse(localStorage.getItem('user_info')).sysUkeyList
        $scope.param = {
            pageNum: 1,
            pageSize: 10,
            param: {
                applyDateBegin: aMonth.start,
                applyDateEnd: aMonth.end,
                applicant: '',
                billCode: '',
                blueInvoiceCode: '',
                blueInvoiceNumber: '',
                busSysId: '',
                buySysName: '',
                custCreditCode: '',
                custName: '',
                diskCode: '',
                diskId: '',
                invType: '',
                invoiceCode: '',
                invoiceNumber: '',
                isList: '',
                orgIds: '',
                saleCreditCode: '',
                saleName: '',
                ukeyCode: '',
                ukeyId: '',
                isRed: '',
                invSort: $scope.isRoll ? '4' : '1',
                custNameCreditCode: '',
                checker: '',
                invoiceSource: '',
                waitInvoiceStatus: '',
                billBatchNo: '',
            },
        }
        $scope.reset = function () {
            $scope.param.param = {
                applyDateBegin: aMonth.start,
                applyDateEnd: aMonth.end,
                applicant: '',
                billCode: '',
                blueInvoiceCode: '',
                blueInvoiceNumber: '',
                busSysId: '',
                buySysName: '',
                custCreditCode: '',
                custName: '',
                diskCode: '',
                diskId: '',
                invType: '',
                invoiceCode: '',
                invoiceNumber: '',
                isList: '',
                orgIds: '',
                saleCreditCode: '',
                saleName: '',
                ukeyCode: '',
                ukeyId: '',
                isRed: '',
                invSort: $scope.isRoll ? '4' : '1',
                custNameCreditCode: '',
                checker: '',
                invoiceSource: '',
                waitInvoiceStatus: '',
                billBatchNo: '',
            }
        }
        // $scope.reset()
        const sessionStr = $scope.isRoll ? 'rollTypeParam' : 'invoiceParam'
        // 表头排序
        $scope.orderMap = initSortService(sessionStr)
        $scope.selectedHandle = function () {
            $scope.param.orderMap = {}
            if ($scope.orderMap.sortKey) $scope.param.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
            sessionStorage.setItem(sessionStr, JSON.stringify($scope.param))
            queryList()
        }
        $scope.selectedInvoices = []
        // 初始化字典值，有前端写死有后台数据字典
        function initDict() {
            const dict = {
                invTypeList: [{
                    enumCode: 0,
                    enumName: '专用发票',
                }, {
                    enumCode: 2,
                    enumName: '普通发票',
                }],
                isRedList: [{
                    enumCode: '0',
                    enumName: '蓝票',
                }, {
                    enumCode: '1',
                    enumName: '红票',
                }],
                waitInvoiceStatusList: [],
            }
            const dictTypeArr = ['wait_invoice_status', 'is_list', 'invoice_source', 'is_pass', 'ovat_tax_rate']
            httpRequest.get_dictByTypeArr(dictTypeArr).then((res1) => {
                Object.assign(dict, res1.data.value)
            })
            httpRequest.post_outSystemList().then((res) => {
                const list = res.data.value
                const result = [{
                    enumTypeCode: null,
                    enumName: '全部',
                    enumCode: '',
                }]
                list.forEach((item) => {
                    const tempdata = {
                        enumTypeCode: null,
                        enumName: '',
                        enumCode: '',
                    }
                    tempdata.enumCode = item.busSysId
                    tempdata.enumName = item.busSysName
                    result.push(tempdata)
                })
                dict.out_system = result
            })

            function toOutSystemdata(list, idfield, textfield) {
                const result = [{
                    enumTypeCode: null,
                    enumName: '全部',
                    enumCode: '',
                }]
                Object.keys(list).forEach((a) => {
                    const tempdata = {
                        enumTypeCode: null,
                        enumName: '',
                        enumCode: '',
                    }
                    tempdata.enumCode = list[a][idfield]
                    tempdata.enumName = list[a][textfield]
                    result.push(tempdata)
                })
                return result
            }
            // 对外系统
            httpRequest.post_outSystemList().then((res) => {
                dict.out_system = toOutSystemdata(res.data.value, 'busSysId', 'busSysName')
            })
            return dict
        }
        $scope.dictionary = initDict()
        // let isSearch = false
        // $scope.$watch('param', () => {
        //     isSearch = false
        // }, true)
        // $scope.$on('$stateChangeStart', (e, toState) => {
        //     if (toState.name.indexOf('outputManage.FOManage.invoice') != -1) {
        //         isSearch && sessionStorage.setItem('invoiceParam', JSON.stringify($scope.param))
        //     }
        //     if (toState.name.indexOf('outputManage.FOManage.rollTypeInvoice') != -1) {
        //         isSearch && sessionStorage.setItem('rollTypeParam', JSON.stringify($scope.param))
        //     }
        // })
        //
        $scope.currentOvatAmt = {}
        $scope.$watch('selectedInvoices.length', () => {
            if (!$scope.selectedInvoices.length) {
                $scope.adValoremTotal = $scope.currentOvatAmt.adValoremTotal
                $scope.invoiceNum = $scope.currentOvatAmt.invoiceNum
                $scope.totalAmt = $scope.currentOvatAmt.totalAmt
                $scope.totalTaxamt = $scope.currentOvatAmt.totalTaxamt
                return
            }
            const {
                adValoremTotal,
                totalAmt,
                totalTaxamt
            } = getOvatAmtService($scope.selectedInvoices)
            $scope.adValoremTotal = adValoremTotal
            $scope.invoiceNum = $scope.selectedInvoices.length
            $scope.totalAmt = totalAmt
            $scope.totalTaxamt = totalTaxamt
        })

        function getData() {
            httpRequest.post_getInvoiceWaitStatics($scope.param).then((res) => {
                $scope.adValoremTotal = res.data.value.adValoremTotal.toFixed(2) || '0.00'
                $scope.invoiceNum = res.data.value.invoiceNum || 0
                $scope.totalAmt = res.data.value.totalAmt.toFixed(2) || '0.00'
                $scope.totalTaxamt = res.data.value.totalTaxamt.toFixed(2) || '0.00'
                $scope.currentOvatAmt = {
                    adValoremTotal: $scope.adValoremTotal,
                    invoiceNum: $scope.invoiceNum,
                    totalAmt: $scope.totalAmt,
                    totalTaxamt: $scope.totalTaxamt
                }
            })
        }

        function queryList() {
            const storageParam = sessionStorage[sessionStr] ? sessionStorage[sessionStr] : sessionStorage.rollTypeParam
            $scope.param = storageParam ? JSON.parse(storageParam) : $scope.param
            const openLoading = $scope.param.pageSize >= 100 ? window.layer.msg('正在查询，请耐心等待', {
                time: 0,
                skin: 'layer-loading-self',
                icon: 16,
                shade: 0.5,
            }) : null
            httpRequest.post_getOvatInvoiceWaitList($scope.param).then((res) => {
                $scope.invoiceList = res.data.value.list
                $scope.totalItems = res.data.value.total
                $scope.param.pageNum = res.data.value.pageNum
                $scope.selectedInvoices = []
            }).finally(() => {
                window.layer.close(openLoading)
            })
            getData()
        }
        $scope.search = function () {
            sessionStorage.setItem(sessionStr, JSON.stringify($scope.param))
            queryList()
        }
        $scope.pageChange = function () {
            sessionStorage.setItem(sessionStr, JSON.stringify({
                orderMap: $scope.param.orderMap,
                pageNum: $scope.param.pageNum,
                pageSize: $scope.param.pageSize,
                param: sessionStorage[sessionStr] ? JSON.parse(sessionStorage[sessionStr]).param : {
                    applyDateBegin: aMonth.start,
                    applyDateEnd: aMonth.end,
                    applicant: '',
                    billCode: '',
                    blueInvoiceCode: '',
                    blueInvoiceNumber: '',
                    busSysId: '',
                    buySysName: '',
                    custCreditCode: '',
                    custName: '',
                    diskCode: '',
                    diskId: '',
                    invType: '',
                    invoiceCode: '',
                    invoiceNumber: '',
                    isList: '',
                    orgIds: '',
                    saleCreditCode: '',
                    saleName: '',
                    ukeyCode: '',
                    ukeyId: '',
                    isRed: '',
                    invSort: $scope.isRoll ? '4' : '1',
                    custNameCreditCode: '',
                    checker: '',
                    invoiceSource: '',
                    waitInvoiceStatus: '',
                    billBatchNo: '',
                },
            }))
            queryList()
        }
        /**
         * 获取是否开启审批流
         */
        function init() {
            httpRequest.post_qryFlowIsValid({
                approveCode: 'opened_invoice_approve',
            }).then((res) => {
                // 开启审批流
                $scope.isFlowOpened = res.data.value
                $scope.param.orderMap = {}
                let profileType = sessionStr == 'rollTypeParam' ? '44' : '5'
                httpRequest.get_getUserCustomized(profileType).then(res => {
                    if (res.data.value) {
                        let orderMap = JSON.parse(res.data.value).orderMap
                        if (orderMap) {
                            $scope.orderMap = orderMap
                        }
                    }
                    if ($scope.orderMap.sortKey) {
                        $scope.param.orderMap[$scope.orderMap.sortKey] = $scope.orderMap.sortVal
                    }
                    sessionStorage.setItem(sessionStr, JSON.stringify($scope.param))
                    queryList()
                })
            })
        }
        init()

        function goAdd(invType) {
            $state.go('outputManage.FOManage.invoice.add', {
                invType,
            })
        }
        $scope.goRollAdd = function goRollAdd() {
            $state.go('outputManage.FOManage.rollTypeInvoice.add')
        }
        $scope.addDropdownConfig = {
            btnText: '新增',
            options: [{
                text: '专用发票',
                handler() {
                    goAdd('0')
                },
            }, {
                text: '普通发票',
                handler() {
                    goAdd('2')
                },
            }],
        }
        $scope.goRed = function goRed() {
            if ($scope.isRoll) {
                $state.go('outputManage.FOManage.rollTypeInvoice.addred')
            } else {
                $state.go('outputManage.FOManage.invoice.addred', {
                    invType: '2',
                })
            }
        }

        function openBatchSubmitResult(result) {
            $uibModal.open({
                template: submitResultPage,
                controller: ['$scope', 'items1', '$uibModalInstance', function ctrl(scope, items1, uibModalInstance) {
                    scope.errorList = items1
                    scope.cancel = function cancel() {
                        uibModalInstance.close()
                    }
                    scope.ok = function ok() {
                        uibModalInstance.close()
                    }
                }],
                openedClass: 'mod-modal mod-modal-lg',
                backdrop: 'static',
                resolve: {
                    items1() {
                        return result
                    },
                },
            }).result.then(() => {
                queryList()
            })
        }

        // 批量开票
        function openBatch(invoiceList, type) {
            function successCallback(errorNum) {
                type && (errorNum = errorNum.length)
                utils.loaded()
                const len = invoiceList.length
                logger.logMsg({
                    title: '操作结果',
                    icon: 1,
                    message: `共计${len}张发票,成功${len - errorNum}张，失败${errorNum}张！`,
                })
                queryList()
            }

            function errorCallback() {
                utils.loaded()
            }

            function notifyCallback(currentIndex = 0) {
                const currentInvoice = invoiceList[currentIndex]
                if ($scope.isRoll) {
                    utils.loading(`正在开具第${currentIndex + 1}张发票， 发票种类卷票`)
                } else {
                    utils.loading(`正在开具第${currentIndex + 1}张发票， 发票种类：${$scope.invTypeMap[currentInvoice.invType]}`)
                }
            }
            const API = type == 2 ? 'a9OpenBatch' : 'openBatch'
            invoiceOpenService[API](invoiceList).then(
                successCallback,
                errorCallback,
                notifyCallback,
            ).finally(() => {
                utils.loaded()
            })
        }

        // 批量开票打印
        function openPrintBatch(invoiceList, diskInfo) {
            function successCallback(errorNum) {
                utils.loaded()
                const len = invoiceList.length
                logger.logMsg({
                    title: '操作结果',
                    icon: 1,
                    message: `共计${len}张发票,成功${len - errorNum}张，失败${errorNum}张！`,
                })
                queryList()
            }

            function errorCallback(error) {
                utils.loaded()
                logger.logError(error.retmsg || error)
            }

            function notifyCallback(currentIndex) {
                const currentInvoice = invoiceList[currentIndex]
                utils.loaded()
                if ($scope.isRoll) {
                    utils.loading(`正在开具第${currentIndex + 1}张发票， 发票种类卷票`)
                } else {
                    utils.loading(`正在开具第${currentIndex + 1}张发票， 发票种类：${$scope.invTypeMap[currentInvoice.invType]}`)
                }
            }
            invoiceOpenService.openPrintBatch(invoiceList, diskInfo.taxCode, diskInfo.machinNo).then(
                successCallback,
                errorCallback,
                notifyCallback,
            ).finally(() => {
                utils.loaded()
            })
        }

        function check(invoiceList, isPrint) {
            const userInfo = JSON.parse(localStorage.getItem('user_info'))
            if (userInfo.org.invoiceFlag !== 1) {
                logger.logError('您所在机构禁止开票，请联系管理员启用')
                return false
            }
            if (userInfo.sale.taxplayerType === '3' ||
                userInfo.sale.taxplayerType === '4' ||
                userInfo.sale.taxplayerType === '9') {
                logger.logError('您所在企业纳税人类型不具备开票资格')
                return false
            }
            if (invoiceOpenService.chechManageTypeDiff(invoiceList)) {
                logger.logError('您选择的发票开票点不是同一个类型的，请重新选择')
                return false
            }
            const {
                invType
            } = invoiceList[0]
            const hasErrorList = []
            for (let i = 0; i < invoiceList.length; i++) {
                if (!invoiceList[i].authMap.WAIT_BILLING) {
                    logger.logError('您选择的数据中有非“审批通过”状态的数据，不能开票，请重新选择')
                    return false
                }
                if (isPrint && invoiceList[i].invType !== invType) {
                    logger.logError('开票打印不能选择多种类型的发票')
                    return false
                }
                if (invoiceList[i].description) {
                    hasErrorList.push({
                        infoId: invoiceList[i].waitId,
                        errorMsg: invoiceList[i].description,
                    })
                }
            }
            return hasErrorList
        }

        function failReasonConfirm(hasErrorList) {
            const defered = $q.defer()
            if (hasErrorList.length === 0) {
                defered.resolve()
                return defered.promise
            }
            // 强行公用批量提交结果页面
            return $uibModal.open({
                template: submitResultPage,
                controller: [
                    '$scope', '$uibModalInstance', 'sweetalert',
                    function ctrl(scope, uibModalInstance, sweetalert) {
                        scope.errorList = hasErrorList
                        scope.msg = '下列发票上次开具失败，请确认是否已经修复'
                        scope.cancel = function cancel() {
                            uibModalInstance.dismiss()
                        }
                        scope.ok = function ok() {
                            let flag = false
                            scope.errorList.forEach(invoice => {
                                if (invoice.errorMsg && (invoice.errorMsg.slice(0, 4) == '4003' || invoice.errorMsg.slice(0, 4) == '4005')) {
                                    flag = true
                                }
                            })
                            if (flag) {
                                sweetalert.confirm('操作提醒', '发票上次写库失败，请先到开票软件进行发票修复后，再点击确认。避免重复开具该发票，造成跳号错觉').then(() => {
                                    uibModalInstance.close()
                                })
                            } else {
                                uibModalInstance.close()
                            }
                        }
                    },
                ],
                backdrop: 'static',
                openedClass: 'mod-modal mod-modal-lg',
            }).result
        }
        $scope.invTypeMap = {
            0: '专用发票',
            2: '普通发票',
        }
        const deleteHaspermit = $scope.isRoll ? 'del_invoice_r' : 'del_invoice'

        function submitCallback(res) {
            utils.loaded()
            if (res.data.value.error) {
                const params = {
                    sourceCount: res.data.value.total,
                    errorCount: res.data.value.error,
                    list: res.data.value.messageList,
                    title: '提交'
                }
                resultTipService.openErrorModal(params, queryList)
            } else {
                logger.logSuccess(`提交成功${res.data.value.total}张票据`)
                queryList()
            }
        }
        $scope.batchDropdownConfig = {
            btnText: '批量操作',
            options: [{
                    text: '批量提交',
                    hasPermit: $scope.isRoll ? 'submit_uninvoice_r' : 'submit_uninvoice',
                    handler() {
                        const waitIds = []
                        if ($scope.selectedInvoices.length === 0) {
                            logger.logError('请选择发票')
                            return
                        }
                        batchFilterService.ovatBatchFilter($scope.selectedInvoices, {
                            condition: {
                                word: 'WAIT_DELETE',
                                val: true
                            },
                            text: '提交'
                        }).then(arr => {
                            for (let i = 0; i < arr.length; i++) {
                                // if (!arr[i].authMap.WAIT_COMMIT) {
                                //     logger.logError('你选择的发票中含有审核中、审核通过的发票，请重新选择')
                                //     return
                                // }
                                waitIds.push(arr[i].waitId)
                            }
                            batchHandle.open().then(data => {
                                utils.loading('系统正在批量处理中，请耐心等待... ')
                                if (data.startRow || data.endRow) {
                                    const subParams = $.extend(data, $scope.param)
                                    httpRequest.post_batchSubmitWaitRange(subParams).then(res => {
                                        submitCallback(res)
                                    })
                                } else {
                                    httpRequest.post_batchSubmitOvatInvoiceWait(waitIds).then((res) => {
                                        submitCallback(res)
                                    })
                                }
                            })

                        })

                    },
                },
                {
                    text: '批量开票',
                    hasPermit: $scope.isRoll ? 'open_invoice_r' : 'open_invoice_z',
                    handler() {
                        if ($scope.selectedInvoices.length === 0) {
                            logger.logError('请选择发票')
                            return
                        }
                        const result = check($scope.selectedInvoices)
                        if (!result) {
                            return
                        }
                        if (invoiceOpenService.chechManageTypeDiff($scope.selectedInvoices)) return logger.logError('您选择的发票开票点不是同一个类型的，请重新选择')
                        utils.loading('开票信息获取中')
                        $scope.invoiceStr = ''

                        let i = 0

                        function fn(ukeyList, invType) {
                            if (i >= ukeyList.length) {
                                utils.loaded()
                                console.log($scope.invoiceStr)
                                sweetalert.confirm('操作提醒', `当前执行批量开票的单据份数为${$scope.selectedInvoices.length}张，请确认${$scope.invoiceStr}`).then(() => {
                                    failReasonConfirm(result).then(() => {
                                        if (invoiceOpenService.checkIsA9($scope.selectedInvoices[0].ukeyId)) {
                                            openBatch($scope.selectedInvoices, 2)
                                        } else {
                                            $scope.errorNum = 0
                                            invoiceOpenService.checkWithDiskInfo($scope.selectedInvoices).then(() => {
                                                $scope.printBatchFlag = false // 是否打印
                                                checkdiffInvType($scope.selectedInvoices)
                                                // openBatch($scope.selectedInvoices)
                                            }, (error) => {
                                                logger.logError(error)
                                            })
                                        }
                                    })
                                })
                            } else {
                                getCodeAndNumber.getStr(ukeyList[i], invType).then(str => {
                                    i++
                                    $scope.invoiceStr += str
                                    fn(ukeyList, invType)
                                })
                            }
                        }
                        getCodeAndNumber.getUkeyList($scope.selectedInvoices).then((ukeyList, invType) => {
                            if ($scope.isRoll) invType = '41'
                            fn(ukeyList, invType)
                        })
                    },
                }, {
                    text: '批量开票打印',
                    hasPermit: $scope.isRoll ? 'open_invoice_r' : 'open_invoice_z',
                    handler() {
                        if ($scope.selectedInvoices.length === 0) {
                            logger.logError('请选择发票')
                            return
                        }
                        const result = check($scope.selectedInvoices, true)
                        if (!result) {
                            return
                        }
                        utils.loading('开票信息获取中')
                        $scope.invoiceStr = ''
                        let i = 0

                        function fn(ukeyList, invType) {
                            if (i >= ukeyList.length) {
                                utils.loaded()

                                sweetalert.confirm('操作提醒', `批量开票完成后将自动执行批量打印操作，若存在多个发票号段，易出现纸质票与需打印的发票电子信息不一致的情况，请检查好可供开具的空白发票号段与打印机上的空白纸质发票是否一致，谨慎操作！${$scope.invoiceStr}`)
                                    .then(() => {
                                        failReasonConfirm(result).then(() => {
                                            $scope.errorNum = 0
                                            if (!invoiceOpenService.checkIsA9($scope.selectedInvoices[0].ukeyId)) {
                                                invoiceOpenService.checkWithDiskInfo($scope.selectedInvoices).then((diskInfo) => {
                                                    // openPrintBatch($scope.selectedInvoices, diskInfo)
                                                    $scope.printBatchFlag = true // 是否打印
                                                    $scope.batchDiskInfo = diskInfo
                                                    checkdiffInvType($scope.selectedInvoices, $scope.batchDiskInfo)
                                                }, (error) => {
                                                    logger.logError(error)
                                                })
                                            }

                                            if (invoiceOpenService.checkIsA9($scope.selectedInvoices[0].ukeyId)) {
                                                $scope.printBatchFlag = true // 是否打印
                                                $scope.batchDiskInfo = {}
                                                checkdiffInvType($scope.selectedInvoices, $scope.batchDiskInfo)
                                            }
                                        })
                                    })
                            } else {
                                getCodeAndNumber.getStr(ukeyList[i], invType).then(str => {
                                    i++
                                    $scope.invoiceStr += str
                                    fn(ukeyList, invType)
                                })
                            }
                        }
                        getCodeAndNumber.getUkeyList($scope.selectedInvoices).then((ukeyList, invType) => {
                            if ($scope.isRoll) invType = '41'
                            fn(ukeyList, invType)
                        })
                    },
                },
                {
                    text: '批量删除',
                    hasPermit: deleteHaspermit,
                    handler() {
                        const waitIds = []
                        if ($scope.selectedInvoices.length === 0) {
                            logger.logError('请选择发票')
                            return
                        }
                        batchFilterService.ovatBatchFilter($scope.selectedInvoices, {
                            condition: {
                                word: 'WAIT_DELETE',
                                val: true
                            },
                            text: '删除'
                        }).then((arr) => {
                            for (let i = 0; i < arr.length; i++) {
                                // if (!arr[i].authMap.WAIT_DELETE) {
                                //     logger.logError('你选择的发票中含有审核中、审核通过的发票，请重新选择')
                                //     return
                                // }
                                waitIds.push(arr[i].waitId)
                            }
                            sweetalert.confirm('操作提醒', '确认删除发票？').then(() => {
                                httpRequest.post_batchDelOvatInvoiceWait(waitIds).then((res) => {
                                    if (res.data.success) {
                                        logger.logSuccess('删除成功')
                                        $timeout(() => {
                                            queryList()
                                        }, 800)
                                    } else {
                                        logger.logError(res.data.errorMsg)
                                    }
                                })
                            })

                        })
                    },
                }, {
                    text: '批量回退',
                    hasPermit: $scope.isRoll ? 'back_invoice_r' : 'back_invoice',
                    handler() {
                        if ($scope.selectedInvoices.length === 0) {
                            logger.logError('请选择发票')
                            return
                        }
                        batchFilterService.ovatBatchFilter($scope.selectedInvoices, {
                            condition: {
                                word: 'WAIT_FALLBACK',
                                val: true
                            },
                            text: '回退'
                        }).then((arr) => {
                            const waitIds = []
                            let redSpecialCount = 0
                            const len = arr.length
                            for (let i = 0; i < len; i++) {
                                // if (!arr[i].authMap.WAIT_FALLBACK) {
                                //     logger.logError(`您当前选中${arr.length}条数据，其中有一部分数据不是“审核通过”状态，不支持回退操作，请筛选后重新选择！`)
                                //     return
                                // }
                                if (arr[i].isRed == '1' && arr[i].invType == '0') {
                                    redSpecialCount += 1
                                }
                                waitIds.push(arr[i].waitId)
                            }
                            const tipMsg = redSpecialCount ? `您当前选中数据里面有${redSpecialCount}条待开具的红字专票，红字专票回退后不可再次提交开具，请再次确认，是否要回退？` : `回退后需要重新提交检测，确认回退吗？`
                            sweetalert.confirm('操作提醒', tipMsg).then(() => {
                                httpRequest.post_batchReductionOvatInvoiceWait(waitIds).then((res) => {
                                    if (res.data.success) {
                                        if (!res.data.value.error) {
                                            logger.logSuccess('回退成功')
                                        } else {
                                            const failCount = res.data.value.error
                                            const successCount = len - failCount
                                            logger.logSuccess(`本次回退${len}条，成功${successCount}条，失败${failCount}条，回退失败的请检查后再次操作！`)
                                        }
                                        $timeout(() => {
                                            queryList()
                                        }, 800)
                                    } else {
                                        logger.logError('回退失败')
                                    }
                                })
                            })

                        })
                    },
                },
            ],
        }

        const soap = (localStorage.soap && JSON.parse(localStorage.soap)) || {}

        function checkdiffInvType(invoiceList, diskInfo) {
            let hasInv2 = false // 存在普票
            let hasdiffInvType = false
            let confirmMsg = '当前为批量开票操作，所勾选的待开发票将开具同种发票联式的发票，请选择需要开具的发票联式：'
            const firstInvoice = invoiceList[0]
            confirmMsg = diskInfo ? '当前为批量开票操作，所勾选的待开发票将开具同种发票联式的发票，请选择需要开具的发票联式，并确保需要开具的发票与空白纸质发票的号段一致' : confirmMsg
            for (let i = 0; i < invoiceList.length; i += 1) {
                if (invoiceList[i].invType == '2') {
                    hasInv2 = true
                }
                if (invoiceList[i].invType !== firstInvoice.invType) {
                    hasdiffInvType = true
                }
            }
            if (hasInv2) {
                httpRequest.get_getTaxDisk(invoiceList[0].ukeyId).then((res) => {
                    if (res.data.value.differentInvoice === 1 && soap.status == 3) { // 普票存在不同联次发票
                        if (hasdiffInvType) {
                            logger.logError('本开票点同时存在2联式和5联式普通发票，请将不同票种分开开具！')
                            return
                        }
                        openIvoiceCofirm('batch', confirmMsg) // 确认后开票
                    } else {
                        $scope.printBatchFlag ? openPrintBatch(invoiceList, diskInfo) : openBatch(invoiceList) // 直接开票
                    }
                })
            } else {
                $scope.printBatchFlag ? openPrintBatch(invoiceList, diskInfo) : openBatch(invoiceList) // 不存在普通票 直接开票
            }
        }
        // 回退
        function reductOvatInvoiceWait(item) {
            httpRequest.post_reductionOvatInvoiceWait(item.waitId, '回退成功').then(() => {
                $timeout(() => {
                    queryList()
                }, 800)
            })
        }
        $scope.reductionOvatInvoiceWait = function reductionOvatInvoiceWait(item, $index) {
            httpRequest.post_checkReductionOvatInvoiceWait(item.waitId).then((res) => {
                if (res.data.value === null) {
                    reductOvatInvoiceWait(item, $index)
                } else {
                    // 确认弹窗
                    $uibModal.open({
                        template: revertDialog,
                        controller: [
                            '$scope', '$uibModalInstance',
                            function ctrl(scope, uibModalInstance) {
                                scope.revertData = res.data.value
                                scope.cancel = function cancel() {
                                    uibModalInstance.dismiss()
                                }
                                scope.ok = function ok() {
                                    uibModalInstance.close()
                                }
                            },
                        ],
                        backdrop: 'static',
                        openedClass: 'mod-modal mod-modal-md',
                        resolve: {
                            items1() {
                                return res.data.value
                            },
                        },
                    }).result.then(() => {
                        reductOvatInvoiceWait(item, $index)
                    })
                }
            })
        }

        function doOpendMethod() {
            if ($scope.singleOrBatch == 'one') {
                $scope.printFlag ? openIvoicePrint($scope.newOpenItem) : openIvoice($scope.newOpenItem) // 直接开票
            } else if ($scope.singleOrBatch == 'batch') {
                $scope.printBatchFlag ? openPrintBatch($scope.selectedInvoices, $scope.batchDiskInfo) : openBatch($scope.selectedInvoices) // 直接开票
            }
        }
        // rewrite
        function cbChangeUnionTypeOpen(data) {
            if (data != null) {
                if (!Object.prototype.hasOwnProperty.call(data, 'value')) {
                    logger.logError(data.retmsg)
                    utils.loaded()
                    return
                }
                const SIDParam = $.parseJSON(data.value)
                // console.log(SIDParam)
                if (SIDParam.InfoTypeCode[8] !== $scope.selectedInvoiceNum) { // 当前代码段和选择代码段不一致 切换号码段并开票
                    invoiceOpenService.queryInvoiceStock().then((res) => { // 金税盘所有库存
                        let param = getChangeObj($scope.selectedInvoiceNum, res) // 获取下一张票
                        if (JSON.stringify(param) !== '{}') { // 有票切换票卷并开票
                            stockService.changeInvoiceUnionType(param).then(() => {
                                doOpendMethod()
                            })
                        } else { //
                            // let inv5Aarry = res.filter(item => (item.invoiceType == "2" && item.categoryCode[8] == "5"))
                            // let inv2Aarry = res.filter(item => (item.invoiceType == "2" && item.categoryCode[8] == "2"))
                            const inv2Aarry10 = res.filter((item) => (item.invoiceType == '2' && item.categoryCode.length == 10 && item.categoryCode[7] == '6' && item.categoryCode[8] == '2'))
                            const inv2Aarry12 = res.filter((item) => (item.invoiceType == '2' && item.categoryCode.length == 12 && item.categoryCode[10] == '0' && item.categoryCode[11] == '4'))
                            const inv2Aarry = [].concat(inv2Aarry10).concat(inv2Aarry12)

                            const inv5Aarry10 = res.filter((item) => (item.invoiceType == '2' && item.categoryCode.length == 10 && item.categoryCode[7] == '6' && item.categoryCode[8] == '5')) // 过滤出纸质票
                            const inv5Aarry12 = res.filter((item) => (item.invoiceType == '2' && item.categoryCode.length == 12 && item.categoryCode[10] == '0' && item.categoryCode[11] == '5')) // 过滤出纸质票
                            const inv5Aarry = [].concat(inv5Aarry10).concat(inv5Aarry12)

                            if ($scope.selectedInvoiceNum == '2' && inv2Aarry.length == 0) {
                                utils.loaded()
                                logger.logError('发票库存不足')
                            }
                            if ($scope.selectedInvoiceNum == '5' && inv5Aarry.length == 0) { // 5联票用完切换
                                utils.loaded()
                                sweetalert.swal({
                                    title: '操作提醒',
                                    text: '当前开票点/金税盘不存在5联式的空白发票，是否继续开具2联式的发票？',
                                    showCancelButton: true,
                                    confirmButtonColor: '#0096e7',
                                    confirmButtonText: '开票',
                                    cancelButtonText: '取消',
                                    closeOnConfirm: true,
                                    closeOnCancel: true,
                                }, (isConfirm) => {
                                    if (isConfirm) {
                                        const msg = $scope.printFlag ? '开票打印中，请耐心等待' : '开票中，请耐心等待'
                                        utils.loading(msg)
                                        param = getChangeObj('2', res) // 切换2联发票开票
                                        if (JSON.stringify(param) !== '{}') {
                                            stockService.changeInvoiceUnionType(param).then(() => {
                                                doOpendMethod()
                                            })
                                        } else {
                                            logger.logError('发票库存不足')
                                        }
                                    }
                                })
                            }
                        }
                    }, err => {
                        utils.loaded()
                        logger.logError(err)
                    })
                } else {
                    doOpendMethod()
                }
            } else {
                utils.loaded()
                logger.logError('读取金税盘失败,为了不影响您的开票操作，确保金税盘启用后，重新刷新页面!')
            }
        }

        function getChangeObj(changeInv, datalist) { // 返回要切换的发票卷信息
            let param = {}
            // let invAarry = datalist.filter(item => (item.invoiceType == "2" && item.categoryCode[8] == changeInv)) //过滤出纸质票
            // 10位发票 2联5联公用
            let invAarry = datalist.filter((item) => (item.invoiceType == '2' && item.categoryCode.length == 10 && item.categoryCode[8] == changeInv)) // 过滤出纸质票
            // 12位 2联
            if (changeInv == '2') {
                const invAarry2 = datalist.filter((item) => (item.invoiceType == '2' && item.categoryCode.length == 12 && item.categoryCode[11] == '4')) // 过滤出纸质票
                invAarry = invAarry.concat(invAarry2)
            }
            if (changeInv == '5') {
                const invAarry3 = datalist.filter((item) => (item.invoiceType == '2' && item.categoryCode.length == 12 && item.categoryCode[11] == '5')) // 过滤出纸质票
                invAarry = invAarry.concat(invAarry3)
            }
            // 12位 5联
            if (invAarry.length > 0 && (changeInv == '2' || changeInv == '5')) { // 金税盘存在联次changeInv的发票卷 返回发票卷参数
                let num = -1
                for (let i = 0; i < invAarry.length; i++) {
                    if (invAarry[i].collectCount > 0) {
                        num = i
                        break
                    }
                }
                if (num >= 0) {
                    param = {
                        invType: '2',
                        invCode: invAarry[num].categoryCode,
                        startNumber: invAarry[num].startNumber,
                    }
                }
            }
            return param
        }

        function lastOpenStep(item, msg, api) {
            invoiceOpenService[api](item).then(() => {
                logger.logSuccess(msg)
            }, (error) => {
                logger.logError(error.retmsg || error)
            }).finally(() => {
                utils.loaded()
                $timeout(() => {
                    queryList()
                }, 800)
            })
        }

        function openIvoice(item) {
            // const result = check([item])//检查是否能开票
            // if (!result) {
            //     return
            // }
            // failReasonConfirm(result).then(() => {//上次开票出现错误，再次开票需确认
            if (item.invType !== '2') {
                utils.loading('开票中，请耐心等待')
                lastOpenStep(item, '开票成功', 'open')
            } else {
                httpRequest.get_getTaxDisk(item.ukeyId).then((res) => {
                    if (res.data.value.differentInvoice !== 1) { // 普票不存在不同联次发票
                        utils.loading('开票中，请耐心等待')
                    }
                    lastOpenStep(item, '开票成功', 'open')
                })
            }

            // })
        }

        function openIvoicePrint(item) {
            const result = check([item])
            if (!result) {
                return
            }
            // failReasonConfirm(result).then(() => {
            if (item.invType !== '2') {
                utils.loading('开票打印中，请耐心等待')
                lastOpenStep(item, '开票打印成功', 'openPrint')
            } else {
                httpRequest.get_getTaxDisk(item.ukeyId).then((res) => {
                    if (res.data.value.differentInvoice !== 1) { // 普票不存在不同联次发票
                        utils.loading('开票打印中，请耐心等待')
                    }
                    lastOpenStep(item, '开票打印成功', 'openPrint')
                })
            }
            // invoiceOpenService.checkDiskAndOpenPrint(item).then(() => {
            //     logger.logSuccess('开票打印成功')
            //     // $scope.goListPage()
            // }, (error) => {
            //     logger.logError(error.retmsg || error)
            // }).finally(() => {
            //     utils.loaded()
            //     queryList()
            // })
            // })
        }

        function openIvoiceCofirm(openType, confirmMsg) { // openType 开票类型 批量或者单张
            $uibModal.open({
                templateUrl: 'paperInvoiceNum.html',
                controller: ['$scope', '$uibModalInstance', 'items1', 'invoiceOpenService', 'logger', function ctrl(scope, uibModalInstance, items1, invoiceOpenService, logger) {
                    utils.loading('开票信息获取中')
                    scope.ivoiceNum = '2' // 默认2联式发票
                    scope.confirmMsg = items1
                    scope.cancel = function cancel() {
                        uibModalInstance.close()
                    }
                    scope.ok = function ok() {
                        uibModalInstance.close(scope.ivoiceNum)
                    }
                    let inv2Aarry = []
                    let inv5Aarry = []
                    scope.ukey = JSON.parse(localStorage.user_info).sysUkeyList.filter(i => {
                        return i.diskCode == localStorage.currentDiskCode
                    })[0]
                    invoiceOpenService.queryInvoiceStock().then((res) => { // 金税盘所有库存
                        const inv2Aarry10 = res.filter((item) => (item.invoiceType == '2' && item.categoryCode.length == 10 && item.categoryCode[7] == '6' && item.categoryCode[8] == '2'))
                        const inv2Aarry12 = res.filter((item) => (item.invoiceType == '2' && item.categoryCode.length == 12 && item.categoryCode[10] == '0' && item.categoryCode[11] == '4'))
                        inv2Aarry = [].concat(inv2Aarry10).concat(inv2Aarry12)

                        const inv5Aarry10 = res.filter((item) => (item.invoiceType == '2' && item.categoryCode.length == 10 && item.categoryCode[7] == '6' && item.categoryCode[8] == '5')) // 过滤出纸质票
                        const inv5Aarry12 = res.filter((item) => (item.invoiceType == '2' && item.categoryCode.length == 12 && item.categoryCode[10] == '0' && item.categoryCode[11] == '5')) // 过滤出纸质票
                        inv5Aarry = [].concat(inv5Aarry10).concat(inv5Aarry12)
                        scope.invoiceCode = inv2Aarry[0] ? inv2Aarry[0].categoryCode : ''
                        scope.invoiceNumber = inv2Aarry[0] ? inv2Aarry[0].startNumber : ''

                    }, err => {
                        logger.logError(err)
                    }).finally(() => {
                        utils.loaded()
                    })
                    scope.$watch('ivoiceNum', () => {
                        if (scope.ivoiceNum == 2) {
                            scope.invoiceCode = inv2Aarry[0] ? inv2Aarry[0].categoryCode : ''
                            scope.invoiceNumber = inv2Aarry[0] ? inv2Aarry[0].startNumber : ''
                        }
                        if (scope.ivoiceNum == 5) {
                            scope.invoiceCode = inv5Aarry[0] ? inv5Aarry[0].categoryCode : ''
                            scope.invoiceNumber = inv5Aarry[0] ? inv5Aarry[0].startNumber : ''
                        }
                    })
                }],
                resolve: {
                    items1() {
                        return confirmMsg
                    },
                },
                openedClass: 'mod-modal mod-modal-md',
                backdrop: 'static',
            }).result.then((result) => {
                if (result) {
                    $scope.selectedInvoiceNum = result // 选中结果
                    if (openType == 'one') {
                        const msg = $scope.printFlag ? '开票打印中，请耐心等待' : '开票中，请耐心等待'
                        utils.loading(msg)
                        $scope.singleOrBatch = 'one'
                    } else if (openType == 'batch') {
                        $scope.singleOrBatch = 'batch'
                    }
                    window.top.TaxCore.tax.invInfo(0, cbChangeUnionTypeOpen, null, null, 0)
                }
            })
        }
        $scope.tableDropdownConfig = [{
                label: '详情',
                handler(item) {
                    let url = 'outputManage.FOManage.invoice.detail'
                    if ($scope.isRoll) {
                        url = 'outputManage.FOManage.rollTypeInvoice.detail'
                    }
                    url = $state.href(url, {
                        waitId: item.waitId,
                    }, {
                        reload: true,
                    })
                    window.open(url, '_blank')
                },
                showWhile() {
                    return true
                },
            },
            {
                label: '编辑',
                handler(item) {
                    if (item.invType === '41') {
                        $state.go('outputManage.FOManage.rollTypeInvoice.edit', {
                            waitId: item.waitId,
                        })
                    } else {
                        $state.go('outputManage.FOManage.invoice.edit', {
                            invType: item.invType,
                            waitId: item.waitId,
                        })
                    }
                },
                showWhile(item, hasPermit) {
                    return item.authMap.WAIT_EDIT && (!$scope.isRoll && hasPermit('add_invoice_z') || $scope.isRoll && hasPermit('add_invoice_r'))
                },
            },
            {
                label: '提交',
                handler(item) {
                    sweetalert.confirm('操作提醒', '确认提交本张发票？').then(() => {
                        invoiceOpenService.submit(item).then(() => {
                            logger.logSuccess('提交成功')
                            $timeout(() => {
                                queryList()
                            }, 800)
                        })
                    })
                },
                showWhile(item, hasPermit) {
                    return (!$scope.isRoll && hasPermit('submit_uninvoice') || $scope.isRoll && hasPermit('submit_uninvoice_r')) && item.authMap.WAIT_COMMIT
                },
            },
            {
                label: '开票',
                handler(item) {
                    const result = check([item]) // 检查是否能开票
                    if (!result) {
                        return
                    }
                    failReasonConfirm(result).then(() => { // 上次开票出现错误，再次开票需确认
                        if (invoiceOpenService.checkIsA9(item.ukeyId)) {
                            utils.loading('开票中，请耐心等待')
                            httpRequest.post_openInvoice({
                                waitId: item.waitId
                            }).then(res => {
                                if (res.data.value.code == 0) {
                                    logger.logSuccess('开票成功')
                                } else {
                                    logger.logError(res.data.value.msg)
                                }
                            }).finally(() => {
                                utils.loaded()
                                $timeout(() => {
                                    queryList()
                                }, 800)
                            })
                        } else {
                            invoiceOpenService.checkWithDiskInfo([item]).then(() => {
                                if (item.invType === '2') {
                                    httpRequest.get_getTaxDisk(item.ukeyId).then((res) => {
                                        if (res.data.value.differentInvoice === 1 && soap.status == 3) { // 普票存在不同联次发票
                                            $scope.newOpenItem = item
                                            $scope.printFlag = false // 是否打印
                                            openIvoiceCofirm('one', '本开票点同时存在5联式和2联式普通发票，请选择需要开具的发票联式：') // 确认后开票
                                        } else {
                                            openIvoice(item) // 直接开票
                                        }
                                    })
                                } else {
                                    openIvoice(item) // 直接开票
                                }
                            }, err => {
                                logger.logError(err)
                            })
                        }
                    })
                },
                showWhile(item, hasPermit) {
                    return ((hasPermit('open_invoice_z') && !$scope.isRoll) || (hasPermit('open_invoice_r') && $scope.isRoll)) && item.authMap.WAIT_BILLING
                },
            },
            {
                label: '开票打印',
                handler(item) {
                    const result = check([item]) // 检查是否能开票
                    if (!result) {
                        return
                    }
                    failReasonConfirm(result).then(() => { // 上次开票出现错误，再次开票需确认
                        if (invoiceOpenService.checkIsA9(item.ukeyId)) {
                            utils.loading('开票打印中，请耐心等待')
                            invoiceOpenService.a9OpenPrint(item).then(res => {
                                logger.logSuccess('开票打印成功')
                            }, err => {
                                logger.logError(err)
                            }).finally(() => {
                                $timeout(() => {
                                    queryList()
                                }, 800)
                                utils.loaded()
                            })
                        } else {
                            invoiceOpenService.checkWithDiskInfo([item]).then(() => {
                                if (item.invType === '2') {
                                    httpRequest.get_getTaxDisk(item.ukeyId).then((res) => {
                                        if (res.data.value.differentInvoice === 1 && soap.status == 3) { // 普票存在不同联次发票
                                            $scope.newOpenItem = item
                                            $scope.printFlag = true // 是否打印
                                            openIvoiceCofirm('one', '本开票点同时存在5联式和2联式普通发票，请选择需要开具的发票联式：') // 确认后开票
                                        } else {
                                            openIvoicePrint(item) // 直接开票
                                        }
                                    })
                                } else {
                                    openIvoicePrint(item) // 直接开票
                                }
                            }, err => {
                                logger.logError(err)
                            })
                        }
                    })
                },
                showWhile(item, hasPermit) {
                    return ((hasPermit('open_invoice_z') && !$scope.isRoll) || (hasPermit('open_invoice_r') && $scope.isRoll)) && item.authMap.WAIT_BILLING_PRINT
                },
            },
            {
                label: '回退',
                handler(item, index) {
                    $scope.reductionOvatInvoiceWait(item, index)
                },
                showWhile(item, hasPermit) {
                    return (!$scope.isRoll && hasPermit('back_invoice') || $scope.isRoll && hasPermit('back_invoice_r')) && item.authMap.WAIT_FALLBACK
                },
            },
            {
                label: '删除',
                handler(item) {
                    sweetalert.confirm('删除提醒', '确认删除此发票?').then(() => {
                        httpRequest.post_delOvatInvoiceWait({
                            waitId: item.waitId,
                        }).then(() => {
                            logger.logSuccess('删除成功')
                            $timeout(() => {
                                queryList()
                            }, 800)
                        })
                    })
                },
                showWhile(item, hasPermit) {
                    return (!$scope.isRoll && hasPermit('del_invoice') || $scope.isRoll && hasPermit('del_invoice_r')) && item.authMap.WAIT_DELETE
                },
            },
        ]
        $scope.customizedConfig = {
            version: 1.6,
            queryForm: [{
                label: '申请日期',
                selected: true,
                default: true,
            }, {
                label: '购方名称/信用代码',
                selected: true,
                default: true,
            }, {
                label: '发票性质',
                selected: false,
                default: false,
            }, {
                label: '申请人',
                selected: false,
                default: false,
            }, {
                label: '清单标志',
                selected: false,
                default: false,
            }, {
                label: '审核状态',
                selected: false,
                default: false,
            }, {
                label: '数据来源',
                selected: false,
                default: false,
            }, {
                label: '开票点',
                selected: false,
                default: false,
            }, {
                label: '单据编号',
                selected: false,
                default: false,
            }, {
                label: '业务系统',
                selected: false,
                default: false,
            }, {
                label: '扩展1',
                selected: false,
                default: false,
            }, {
                label: '扩展2',
                selected: false,
                default: false,
            }, {
                label: '扩展3',
                selected: false,
                default: false,
            }, {
                label: '发票种类',
                selected: true,
                default: true,
            }],
            table: [{
                    label: '待开编号',
                    selected: false,
                    default: false,
                }, {
                    label: '发票性质',
                    selected: true,
                    default: true,
                }, {
                    label: '购方名称/信用代码',
                    selected: true,
                    default: true,
                }, {
                    label: '购方地址电话',
                    selected: false,
                    default: false,
                },
                {
                    label: '购方开户行及账号',
                    selected: false,
                    default: false,
                }, {
                    label: '申请日期',
                    selected: true,
                    default: true,
                }, {
                    label: '审核状态',
                    selected: false,
                    default: false,
                }, {
                    label: '失败原因',
                    selected: true,
                    default: true,
                }, {
                    label: '合计金额/税额',
                    selected: true,
                    default: true,
                }, {
                    label: '价税合计',
                    selected: false,
                    default: false,
                }, {
                    label: '含税折扣金额',
                    selected: false,
                    default: false,
                }, {
                    label: '备注',
                    selected: false,
                    default: false,
                }, {
                    label: '主商品名称',
                    selected: false,
                    default: false,
                }, {
                    label: '税率',
                    selected: false,
                    default: false,
                }, {
                    label: '开票点',
                    selected: false,
                    default: false,
                }, {
                    label: '关联销售单',
                    selected: false,
                    default: false,
                }, {
                    label: '单据编号',
                    selected: true,
                    default: true,
                }, {
                    label: '数据来源',
                    selected: false,
                    default: false,
                }, {
                    label: '清单标志',
                    selected: false,
                    default: false,
                }, {
                    label: '申请人',
                    selected: false,
                    default: false,
                }, {
                    label: '销方开户行及账号',
                    selected: false,
                    default: false,
                },
                {
                    label: '扩展1',
                    selected: false,
                    default: false,
                }, {
                    label: '扩展2',
                    selected: false,
                    default: false,
                }, {
                    label: '扩展3',
                    selected: false,
                    default: false,
                }, {
                    label: '发票种类',
                    selected: false,
                    default: false,
                }
            ],
        }
        if ($scope.isRoll) {
            $scope.customizedConfig.queryForm.splice(-1, 1)
            $scope.customizedConfig.table.splice(-1, 1)
        }
        $scope.filterUkeyName = function filterUkeyName(id) {
            const userInfo = JSON.parse(localStorage.getItem('user_info'))
            if (id === null) {
                return id
            }
            if (userInfo.sysUkeyList === null) {
                return id
            }
            const fliterUkeyNameArr = userInfo.sysUkeyList.filter((item) => item.ukeyId === id)
            if (fliterUkeyNameArr.length > 0) {
                return fliterUkeyNameArr[0].ukeyName
            }
            return id
        }

        // *******
        // tab切换
        $scope.vehicleInvPageShow = false
        $scope.tabChange = function tabChange(v) {
            $scope.vehicleInvPageShow = (v === 2)
        }

        // 查看关联销售单
        $scope.relatedBill = function relatedBill(item) {
            if (item.billNum === 0) {
                return
            }
            if (item.waitId === undefined) {
                return
            }
            if ($scope.isRoll) {
                $state.go('outputManage.FOManage.rollTypeInvoice.relatedBill', {
                    waitId: item.waitId,
                })
            } else {
                $state.go('outputManage.FOManage.invoice.relatedBill', {
                    waitId: item.waitId,
                })
            }
        }

        // 状态按钮滑过
        $scope.showCheckStream = function (row, flag) {
            row.dropdowstatenhover = flag
        }
        // 下载导入模板
        $scope.downOvatBill = function (type) {
            // type 1 专普 2卷票
            if (type == 1) {
                window.open(`${host.etcloudOvat}dlTaskService/export_OVAT_INVOICE_COMMON?accessToken=${localStorage.getItem('id_token')}`)
            } else {
                window.open(`${host.etcloudOvat}dlTaskService/export_OVAT_INVOICE_ROLL?accessToken=${localStorage.getItem('id_token')}`)
            }
        }
        $scope.open = function () {
            if (!JSON.parse(localStorage.user_info).sale) {
                logger.logError('该机构未配置纳税人信息，不能进行该操作')
                return
            }
            $scope.item = {
                queryOvatBillList: queryList,
                code: 'OVAT_INVOICE_COMMON',
            }
            if ($scope.isRoll) {
                $scope.item.code = 'OVAT_INVOICE_ROLL'
            }
            const modalInstance = $uibModal.open({
                templateUrl: './app/outputManage/fillOpenManage/ovatBill/view/ovatBillModalCtrl.html',
                controller: 'ovatBillModalCtrl',
                openedClass: 'et-ovat-bill-modal mod-modal mod-modal-lg',
                backdrop: 'static',
                resolve: {
                    items1() {
                        return $scope.item
                    },
                },
            })
            modalInstance.result.then(() => {
                // console.log(222)
                queryList()
            }, () => {
                // console.log(111)
            })
        }
    }
}
InvoiceListCtrl.$inject = ['$scope', '$uibModal', 'logger', 'httpRequest', '$q', '$state', 'sweetalert', 'invoiceOpenService', 'initSortService', '$timeout', 'getOvatAmtService', 'resultTipService', 'batchHandle', 'getCodeAndNumber', 'batchFilterService']


// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/invoice1/InvoiceListCtrl.js